<div *ngIf="applicantInterview" class="ui basic segment" [class.loading]="isLoading">
    <div>
        <app-header
            [back]="true"
            [title]="this.applicantInterview.interview?.name"
            [subtitle]="{
                key: 'applicant-tracker.interviewFor',
                params: { name: applicantInterview.applicant?.fullName },
            }"
        >
            <div class="buttons margin-top-5">
                <div *ngIf="isSaving" class="flex end margin-bottom-2">
                    <mat-progress-spinner color="primary" mode="indeterminate" diameter="20"> </mat-progress-spinner>
                    <p class="margin-left-1">{{ 'applicant-tracker.savingWithPeriods' | appTranslate }}</p>
                </div>

                <div *ngIf="!isSaving" class="flex end margin-bottom-2">
                    <mat-icon class="checkmark green" svgIcon="check"></mat-icon>
                    <p class="margin-left-1">{{ 'applicant-tracker.savedExclamation' | appTranslate }}</p>
                </div>
            </div>
        </app-header>
    </div>

    <div class="app-grid">
        <div class="columns-3">
            <ui-card>
                <app-segment-header title="applicant-tracker.details"></app-segment-header>
                <div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.applicantName' | appTranslate }}</div>
                        <div class="value">
                            {{ applicantInterview.applicant?.fullName }}
                            <a (click)="goToApplicantPage(applicantInterview.applicant)">
                                <mat-icon class="margin-left-1" svgIcon="openInNew"></mat-icon>
                            </a>
                        </div>
                    </div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.feedbackDueBy' | appTranslate }}</div>
                        <div class="value">{{ applicantInterview.feedbackDueDate | appDate: 'longDate' }}</div>
                    </div>
                    <div class="interview-attribute margin-bottom-3">
                        <div class="name margin-bottom-1">{{ 'applicant-tracker.description' | appTranslate }}</div>
                        <div class="value">{{ applicantInterview.interview?.description }}</div>
                    </div>
                </div>
            </ui-card>
        </div>
        <div class="columns-9 question-answers">
            <ui-card data-cy="question-card">
                <app-segment-header title="applicant-tracker.questions"></app-segment-header>
                <div
                    class="app-grid"
                    [class.margin-top-5]="!first"
                    *ngFor="let interviewQuestion of interviewQuestions; let index = index; let first = first"
                >
                    <div class="question-title columns-12 margin-bottom-1">
                        {{ index + 1 }}.

                        <span class="bold-titles"
                            >{{ interviewQuestion.question }}{{ interviewQuestion.isRequired ? '*' : '' }}
                        </span>
                    </div>

                    <div class="columns-12 margin-left-3">
                        <!-- Open Question -->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name ===
                                applicantInterviewQuestionTypes.openQuestion
                            "
                        >
                            <mat-form-field class="no-top-padding open-question-textarea">
                                <textarea
                                    [ngModel]="getTextForOpenQuestion(interviewFeedbacks[index])"
                                    [ngModelOptions]="{ updateOn: 'blur' }"
                                    (ngModelChange)="onTextForOpenChange($event, interviewFeedbacks[index])"
                                    rows="9"
                                    [attr.name]="'open-question-' + index"
                                    matInput
                                ></textarea>
                            </mat-form-field>
                        </ng-container>

                        <!-- Yes / No -->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name === applicantInterviewQuestionTypes.yesNo
                            "
                        >
                            <mat-radio-group
                                [ngModel]="getYesNoValue(interviewFeedbacks[index])"
                                (ngModelChange)="onYesNoValueChange($event, interviewFeedbacks[index])"
                                class="vertical"
                            >
                                <mat-radio-button value="yes">{{ 'yes' | appTranslate }}</mat-radio-button>
                                <mat-radio-button value="no">{{ 'no' | appTranslate }}</mat-radio-button>
                            </mat-radio-group>
                        </ng-container>

                        <!-- Multiple Choice-->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name ===
                                applicantInterviewQuestionTypes.multipleChoice
                            "
                        >
                            <app-interview-multiple-choice
                                [interviewQuestion]="interviewQuestion"
                                [interviewerFeedback]="getMultipleChoiceValue(interviewFeedbacks[index])"
                                (valueChange)="onMultipleChoiceChange($event, interviewFeedbacks[index])"
                            ></app-interview-multiple-choice>
                        </ng-container>

                        <!-- Opinion Scale-->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name ===
                                applicantInterviewQuestionTypes.opinionScale
                            "
                        >
                            <app-interview-opinion-scale
                                [interviewQuestion]="interviewQuestion"
                                (valueChange)="onOpnionScaleChange($event, interviewFeedbacks[index])"
                                [value]="getOpinionScaleValue(interviewFeedbacks[index])"
                            ></app-interview-opinion-scale>
                        </ng-container>
                    </div>
                </div>
            </ui-card>
            <ui-card class="final-eval" data-cy="Final-eval">
                <app-segment-header title="applicant-tracker.finalEvaluation"> </app-segment-header>
                <p>
                    {{
                        {
                            key: 'applicant-tracker.selectWhetherNamePassedOrFailed',
                            params: { name: applicantInterview.applicant?.fullName },
                        } | appTranslate
                    }}
                </p>
                <div class="flex justify-center margin-top-2">
                    <mat-radio-group
                        [(ngModel)]="applicantInterviewer.evaluation"
                        class="flex justify-center"
                        style="width: 100%"
                    >
                        <div class="flex eval-border margin-right-2 justify-center align-items-center">
                            <mat-icon class="checkmark large green margin-bottom-3" svgIcon="check"></mat-icon>
                            <div class="break"></div>
                            <mat-radio-button [attr.name]="'passed'" [value]="interviewerEvaluationsTypes.Passed">{{
                                'applicant-tracker.passed' | appTranslate
                            }}</mat-radio-button>
                        </div>
                        <div class="flex eval-border margin-left-2 justify-center align-items-center">
                            <mat-icon class="cross margin-bottom-3" svgIcon="close"></mat-icon>
                            <div class="break"></div>
                            <mat-radio-button [attr.name]="'failed'" [value]="interviewerEvaluationsTypes.Failed">{{
                                'applicant-tracker.failed' | appTranslate
                            }}</mat-radio-button>
                        </div>
                    </mat-radio-group>
                </div>
            </ui-card>
            <ui-button
                [disabled]="applicantInterviewer.evaluation === interviewerEvaluationsTypes.Pending"
                (click)="submitEvaluation()"
                style="float: right"
                type="primary"
                >{{ 'submit' | appTranslate }}</ui-button
            >
        </div>
    </div>
</div>
